import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { DialogsService } from 'app/_services/dialogs/dialogs.service';
import { LegislationService } from 'app/_services/legislation.service';
import { NotificationService } from 'app/_services/notification.service';
import { LegislationGroup, LEGISLATION_GROUPS_COLUMNS } from '../../legislation-items/legislation';
import { AddEditLegislationGroupDialogComponent } from '../add-edit-group-dialog/add-edit-group-dialog.component';


@Component({
    selector: 'app-legislation-groups',
    templateUrl: './legislation-groups.component.html',
    styleUrls: ['../../../shared/table-defaults.scss', '../../legislation.component.scss', './legislation-groups.component.scss'],
})
export class LegislationGroupsComponent implements OnInit {
    isLoading = true;
    // emailRecipients: EmailRecipient[];
    legislationGroups: LegislationGroup[];
    groupNames: string[];
    dataSource: MatTableDataSource<LegislationGroup>;

    groupsColumns = LEGISLATION_GROUPS_COLUMNS;
    columnsToDisplay = [ ...LEGISLATION_GROUPS_COLUMNS, 'actions'];
    
    @ViewChild(MatTable) table: MatTable<LegislationGroup>;
    
    constructor(
        public dialog: MatDialog,
        private dialogService: DialogsService,
        private legislationService: LegislationService,
        private notificationService: NotificationService
    ) {}
    
    ngOnInit(): void {
        const self = this;
        self.isLoading = false;

        self.legislationService.getLegislationGroups().subscribe((groups) => {
            self.legislationGroups = groups;
            self.loadDatasource(self.legislationGroups);

            // Create list of group names to pass into dialog for name validation.
            self.groupNames = self.legislationGroups.map((group) => group.groupName);
            self.isLoading = false;
        });
    }

    trackBy(_index: number, legislationGroup: LegislationGroup) {
        return legislationGroup.groupId;
    }

    loadDatasource(data: LegislationGroup[]): void {
        this.dataSource = null;
        this.dataSource = new MatTableDataSource(data);
    }


    applyFilter(searchTerms: any): void {
        this.dataSource.filter = searchTerms;

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    clearFilter(): void {
        this.dataSource.filter = '';

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    openLegislationGroupDialog(legislationGroup: LegislationGroup, groupNames: string[], title: string): MatDialogRef<AddEditLegislationGroupDialogComponent> {
        const config: MatDialogConfig = {
            // disableClose: true,
            width: '450px',
            panelClass: 'edit-legislation-group',
            data: { legislationGroup, groupNames, title },
        };

        return this.dialog.open(AddEditLegislationGroupDialogComponent, config);
    }

    newGroup(): LegislationGroup {
        return {
            groupId: 0,
            groupName: '',
        }
    }

    addGroup(): void {
        const self = this;
        const legislationGroups = self.legislationGroups;
        const groupNames = self.groupNames;
        const title = 'Add Group';
        
        const group = self.newGroup();

        const dialogResult = self.openLegislationGroupDialog(group, groupNames, title);

        dialogResult.afterClosed().subscribe((result: LegislationGroup) => {
            if (!result) {
                return;
            }

            self.legislationService.createLegislationGroup(result).subscribe((res) => {
                legislationGroups.push(res);
                self.loadDatasource(legislationGroups);
                self.notificationService.showSuccess(`New Legislation Group has been added.`);
            });
        });
    }

    editGroup(legislationGroup: LegislationGroup): void {
        const self = this;
        const groupNames = self.groupNames;
        
        const title = `Edit Legislation Group - ${legislationGroup.groupName}`;

        const dialogResult = self.openLegislationGroupDialog(legislationGroup, groupNames, title);

        dialogResult.afterClosed().subscribe((result: LegislationGroup) => {
            if (!result) {
                return;
            }
            
            self.legislationService.updateLegislationGroup(result.groupId, result).subscribe();
            self.table.renderRows();
            self.notificationService.showSuccess(`Legislation Group has been updated.`);
        });
    }

    deleteGroup(legislationGroup: LegislationGroup): void {
        const self = this;
        const dialogResult$ = self.dialogService.OpenConfirmationDialog({
            TitleText: 'Delete Legislation Group',
            MessageText: 'Are you sure you want to remove this group?',
            SubMessageText: 'Deleting this group will also remove it from all assigned legislation members. THIS CANNOT BE UNDONE!',
            OKText: 'Yes, remove group',
            CancelText: 'No',
            DelayDelete: 5, // Number of seconds to delay delete button
        });

        dialogResult$.subscribe((result) => {
            if (!result) {
                return;
            }

            const index = self.dataSource.data.indexOf(legislationGroup, 0);

            if (index > -1) {
                self.dataSource.data.splice(index, 1);
            }

            self.legislationService.deleteLegislationGroup(legislationGroup.groupId).subscribe();
            self.table.renderRows();
            self.notificationService.showSuccess(`Legislaiton Group have been removed.`);
        });
    }
}